export function getInternalUrl(str: string): string | null {
  const url = new URL(str, location.origin);
  if (!url.toString().startsWith(location.origin)) return null;
  // it is either a relative url without starting slash (that we don't tolerate),
  // or a protocol-less external url (we decide for this)
  if (url.pathname === "/" + str && (str.match(/[.]/g)?.length ?? 0) >= 2) return null;
  return url.pathname + url.search;
}

export function convertToExternalUrl(str: string): string {
  let url = new URL(str, location.origin);
  // if it starts with protocol, we are done
  if (str.startsWith(url.protocol)) return str;
  // if not then prepend current protocl
  return new URL("//" + str, location.origin).toString();
}
